<mat-table [dataSource]="dataSource" matSort matSortDisableClear matSortActive="" matSortDirection="asc"
    style="width: 100%; min-width:1050px;" aria-label="Attendance Details Table" tabindex="-1">
    <ng-container matColumnDef="AddedBy">
        <mat-header-cell *matHeaderCellDef mat-sort-header><span translate>Added By</span></mat-header-cell>
        <mat-cell *matCellDef="let detail">{{detail.BasePage ? '' : detail.AddedByName}}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="AddedOn">
        <mat-header-cell *matHeaderCellDef mat-sort-header><span translate>Added</span></mat-header-cell>
        <mat-cell *matCellDef="let detail">
            <span>{{detail.BasePage ? '' : (detail.AddedOn | date:'MM/dd/yy')}}</span>
        </mat-cell>
    </ng-container>
    <ng-container matColumnDef="LastUpBy">
        <mat-header-cell *matHeaderCellDef mat-sort-header><span translate>Last Updated By</span></mat-header-cell>
        <mat-cell *matCellDef="let detail">{{detail.BasePage ? '' : detail.LastUpByName}}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="LastUpOn">
        <mat-header-cell *matHeaderCellDef mat-sort-header><span translate>Last Updated</span></mat-header-cell>
        <mat-cell *matCellDef="let detail">
            <span>{{detail.BasePage ? '' : (detail.LastUpOn | date:'MM/dd/yy h:mm a')}}</span>
        </mat-cell>
    </ng-container>
    <ng-container matColumnDef="Description">
        <mat-header-cell *matHeaderCellDef mat-sort-header><span translate>Description</span></mat-header-cell>
        <mat-cell *matCellDef="let detail">{{detail.Description}}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="Status">
        <mat-header-cell *matHeaderCellDef mat-sort-header><span translate>Active</span></mat-header-cell>
        <mat-cell *matCellDef="let detail" style="display:flex; justify-content:center;">
            <span *ngIf="detail.Active">Y</span>
            <span *ngIf="!detail.Active"></span>
          </mat-cell>
    </ng-container>
    <ng-container matColumnDef="Actions">
        <mat-header-cell *matHeaderCellDef> Actions </mat-header-cell>
        <mat-cell *matCellDef="let detail; let i = dataIndex;">
          <tyl-mat-menu id="tblCustomFieldsActionMenu{{i}}" image="actions.png" [iconWidth]="30">
            <button id="view{{i}}" aria-label="View Page" mat-menu-item class="menuItem" (click)="viewClick(detail)" *ngIf="allowViewEdit">View</button>
            <mat-divider *ngIf="allowViewEdit && (!detail.BasePage || !detail.Active)"></mat-divider>
            <button id="Activate{{i}}" aria-label="" mat-menu-item class="menuItem" *ngIf="!detail.Active" (click)="toggleActiveStatusClick(detail)">
                   <span>Activate</span>
            </button>
            <button id="duplicate{{i}}" aria-label="Duplicate Page" mat-menu-item class="menuItem" (click)="duplicateClick(detail)" *ngIf="allowViewEdit && !detail.BasePage">Duplicate</button>
            <button id="editDescription{{i}}" aria-label="Edit Description" mat-menu-item class="menuItem" (click)="editDescriptionClick(detail)" *ngIf="!detail.BasePage">Edit Description</button>
            <button id="Edit{{i}}" aria-label="Edit Page" mat-menu-item class="menuItem" (click)="editClick(detail)" *ngIf="allowViewEdit && !detail.BasePage">Edit Page</button>
            <mat-divider *ngIf="!detail.BasePage"></mat-divider>
            <button id="Delete{{i}}" aria-label="Delete Page" mat-menu-item class="menuItem" (click)="deleteClick(detail)" *ngIf="!detail.BasePage">Delete</button>
          </tyl-mat-menu>
        </mat-cell>
      </ng-container>

    <mat-header-row *matHeaderRowDef="columnsToDisplay" tabindex="-1">
    </mat-header-row>
    <mat-row *matRowDef="let row; let i = index; columns: columnsToDisplay" tabindex="0">
    </mat-row>
</mat-table>